<template>
    <div class="controls-footer__wrapper">
        <Cta type="secondary" size="lg" label="Add to Wishlist" @onClick="addToWishlist()" :icon="['fasr', 'heart']" iconAlignment="left"></Cta>
        <div class="controls-footer__section">
            <Cta type="secondary" size="lg" :useLabelAsTitleOnly="true" label="Download" :icon="['fa-light', 'fa-down-to-line']" @onClick="download()" iconAlignment="left" :noIconPadding="true"> </Cta>
            <Cta type="secondary" size="lg" :useLabelAsTitleOnly="true" label="Print" :icon="['fasl', 'fa-print']" iconAlignment="left" @onClick="print()" :noIconPadding="true"> </Cta>
            <Cta type="secondary" size="lg" :useLabelAsTitleOnly="true" label="Share" :icon="['fa-light', 'fa-share-nodes']" iconAlignment="left" @onClick="share()" :noIconPadding="true"> </Cta>
        </div>
        <Cta type="secondary" size="lg" label="Advanced Filters" :icon="['fasl', 'fa-filter']" iconAlignment="left" @onClick="handleAdvancedFilters"> </Cta>
    </div>
</template>

<script lang="ts" setup>
import Cta from './shared/Cta.vue';
import { computed, onMounted } from 'vue';
import { LockDesignerPDF } from 'Api/apis';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';
import { OptionChanged } from 'Vue/interfaces/LockDesigner';
import AdvancedFiltersModal from './shared/Modals/AdvancedFiltersModal.vue';

const componentName = 'ControlsFooter';
const store = useStore();

const toast = useToast();
const router = useRouter();
//const savedAuthToken = ref(localStorage.getItem('authToken') || '');

const addToWishlist = () => {
    //If the user is logged in go to the wishlist
    //If not then prompt them to login
    if (store?.state?.authToken) {
        router.push('/lock-designer/wishlist-add');
    } else {
        router.push('/lock-designer/login');
    }
};

const share = () => {
    router.push('/lock-designer/share');
};

const requestObject = computed(() => {
    return {
        selections: store?.state?.selections,
        optionChanged: OptionChanged.None,
        exterior: store?.state?.selections?.exterior,
    };
});

const print = async () => {
    toast.success(`A PDF of your Baldwin Lock Designer Configuration is currently generating. This may take a few minutes. Upon completion open the PDF to print.`, {
        timeout: false,
    });
    await LockDesignerPDF(requestObject.value).then((response) => {
        setTimeout(() => {
            toast.clear();
        }, 3000);
    });
};
const handleAdvancedFilters = async() => {
    await store.dispatch('openModal', { component: AdvancedFiltersModal });
};

const download = () => {
    let downloadImage = () => {
        let imageUrl = store?.state?.selections?.scene7ImageUrl ? `${store?.state?.selections?.scene7ImageUrl}&fmt=png-alpha` : 'https://images.baldwinhardware.com/is/image/Baldwin/lockdesigner-error';
        let fileName = 'lock-designer-image.png';

        // Create a link element
        let link = document.createElement('a');

        // Fetch the image as a Blob
        fetch(imageUrl)
            .then((response) => response.blob())
            .then((blob) => {
                // Create a Blob URL
                // Set the link's attributes
                link.href = URL.createObjectURL(blob);
                link.download = fileName;

                // Append the link to the document body
                document.body.appendChild(link);

                // Trigger a click event on the link
                link.click();

                // Remove the link from the document
                document.body.removeChild(link);
            })
            .catch((error) => {
                console.error('Error fetching image:', error);
            });
    };

    downloadImage();
    toast.success(`An image of your configured door selections has been downloaded successfully`, {
        timeout: 2000,
    });
};

onMounted(() => {
    // const lsToken = localStorage.getItem('authToken');
    // if (lsToken) {
    //     savedAuthToken.value = lsToken;
    //     store.state.authToken = lsToken;
    // }
});
</script>
